import React, { useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { Loading } from '..';
export var CustomInfiniteScroll = function (options) {
    useEffect(function () {
        window.addEventListener('scroll', handleScroll, { passive: true });
        return function () { return window.removeEventListener('scroll', handleScroll); };
    }, []);
    var handleScroll = function () {
        if ((window.innerHeight + window.scrollY) * 1.2 >= document.body.offsetHeight)
            if (options.nextUrl && navigator.onLine)
                options.paginate();
    };
    var renderChildrenWithPaginator = function () { return (React.createElement(InfiniteScroll, { pageStart: 0, loadMore: function () { return options.paginate(); }, hasMore: !!(options.nextUrl && navigator.onLine), loader: React.createElement(Loading, null) }, options.children)); };
    return (React.createElement("div", { className: 'paginator-container' }, options.firstLoading ? React.createElement(Loading, null) : renderChildrenWithPaginator()));
};
//# sourceMappingURL=InfiniteScroll.js.map